import PropTypes from "prop-types";
import { useState } from "react";
import { CheckOutlined } from "@/config/antd";
import Button from "@/components/common/Button";
import Delete from "@/components/common/alerts/Delete";
import WebIcon from "@/components/common/Web_Icons";

const CreatorCard = ({ publicLink, onClosePoll }) => {
  const [copied, setCopied] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const handleCopy = () => {
    if (!publicLink) return;
    navigator.clipboard.writeText(publicLink).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <>
      {/* Survey link card */}
      <div className="bg-white rounded-lg border border-[#E1F0FF] p-5 mb-4">
        <h3 className="font-bold text-darkGrey text-regular mb-4">
          Public Survey Link
        </h3>

        {/* URL box */}
        <div className="flex items-center gap-2 border border-[#E1F0FF] rounded-md px-3 py-2 mb-3 bg-[#F8FBFF]">
          <span
            className="flex-1 text-small text-lighterGrey truncate"
            title={publicLink}>
            {publicLink || "No public link available"}
          </span>
          <button
            type="button"
            onClick={handleCopy}
            disabled={!publicLink}
            className="flex-shrink-0 text-primary hover:text-primary/80 transition-colors disabled:opacity-40 cursor-pointer"
            aria-label="Copy link">
            {copied ? (
              <CheckOutlined style={{ fontSize: 14 }} />
            ) : (
              <WebIcon icon="BlueCopy" className="w-4 h-4 cursor-pointer" />
            )}
          </button>
        </div>

        <p className="text-small text-lighterGrey leading-relaxed">
          Anyone with this link can view the public poll page and submit a
          response according to your visibility rules.
        </p>
      </div>

      {/* Close Poll Early button */}
      <Button
        text="Close Poll Early"
        icon={<WebIcon icon="BlueCancel" className="w-4 h-4" />}
        iconPosition="left"
        onClick={() => setShowConfirm(true)}
        customBgColor="white"
        customTextColor="danger"
        fontWeight="bold"
        rounded="lg"
        className="w-full border-2 border-danger h-[56px] font-medium hover:bg-white"
      />

      {/* Confirmation modal */}
      <Delete
        isVisible={showConfirm}
        onClose={() => setShowConfirm(false)}
        onProceed={() => {
          setShowConfirm(false);
          if (onClosePoll) onClosePoll();
        }}
        header="Close Poll Early"
        paragraph="Are you sure you want to close this poll before its scheduled end date? This action cannot be undone."
        proceedButtonText="Close Poll"
        cancelButtonText="Cancel"
      />
    </>
  );
};

CreatorCard.propTypes = {
  publicLink: PropTypes.string,
  onClosePoll: PropTypes.func,
};

export default CreatorCard;
